import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/coming-soon.jpg'
import _imports_1 from '@/assets/images/logo-big.svg'
import _imports_2 from '@/assets/images/white-logo-big.svg'


const _hoisted_1 = { class: "bg-white dark:bg-[#0a0e19] py-[30px] h-screen overflow-x-hidden" }
const _hoisted_2 = { class: "w-full h-full table" }
const _hoisted_3 = { class: "table-cell align-middle" }
const _hoisted_4 = { class: "mx-auto px-[12.5px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1255px]" }
const _hoisted_5 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-[25px] items-center" }
const _hoisted_6 = { class: "xl:ltr:pl-[90px] xl:rtl:pr-[90px] 2xl:ltr:pl-[120px] 2xl:rtl:pr-[120px] order-1 lg:order-2" }
const _hoisted_7 = {
  class: "countdown mb-[10px]",
  id: "comingSoonCountDown"
}
const _hoisted_8 = { class: "inline-block ltr:mr-[20px] ltr:md:mr-[25px] rtl:ml-[20px] rtl:md:ml-[25px] mb-[15px]" }
const _hoisted_9 = {
  id: "days",
  class: "block text-black dark:text-white font-bold text-xl lg:text-2xl"
}
const _hoisted_10 = { class: "inline-block ltr:mr-[20px] ltr:md:mr-[25px] rtl:ml-[20px] rtl:md:ml-[25px] mb-[15px]" }
const _hoisted_11 = {
  id: "hours",
  class: "block text-black dark:text-white font-bold text-xl lg:text-2xl"
}
const _hoisted_12 = { class: "inline-block ltr:mr-[20px] ltr:md:mr-[25px] rtl:ml-[20px] rtl:md:ml-[25px] mb-[15px]" }
const _hoisted_13 = {
  id: "minutes",
  class: "block text-black dark:text-white font-bold text-xl lg:text-2xl"
}
const _hoisted_14 = { class: "inline-block ltr:mr-[20px] ltr:md:mr-[25px] rtl:ml-[20px] rtl:md:ml-[25px] mb-[15px]" }
const _hoisted_15 = {
  id: "seconds",
  class: "block text-black dark:text-white font-bold text-xl lg:text-2xl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "xl:ltr:-mr-[25px] xl:rtl:-ml-[25px] rounded-md order-2 lg:order-1" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "coming-soon-image",
                class: "rounded-md"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _cache[4] || (_cache[4] = _createStaticVNode("<img src=\"" + _imports_1 + "\" alt=\"logo\" class=\"inline-block dark:hidden\"><img src=\"" + _imports_2 + "\" alt=\"logo\" class=\"hidden dark:inline-block\"><div class=\"my-[17px] md:my-[25px]\"><h1 class=\"font-semibold text-[22px] md:text-xl lg:text-2xl 2xl:text-4xl mb-[5px] md:mb-[12px]\"> We&#39;re working on launching soon, stay tuned! </h1><p class=\"font-medium leading-[1.5] lg:text-md\"> We&#39;re coming soon.. </p></div>", 3)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.countdown.days), 1),
                  _cache[0] || (_cache[0] = _createTextVNode(" Days "))
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.countdown.hours), 1),
                  _cache[1] || (_cache[1] = _createTextVNode(" Hours "))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.countdown.minutes), 1),
                  _cache[2] || (_cache[2] = _createTextVNode(" Minutes "))
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.countdown.seconds), 1),
                  _cache[3] || (_cache[3] = _createTextVNode(" Seconds "))
                ])
              ]),
              _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"mb-[15px] relative\"><label class=\"mb-[10px] md:mb-[12px] text-black dark:text-white font-medium block\"> Be the first to know when our site is live </label><input type=\"text\" class=\"h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500\" placeholder=\"example@clickai.live\"></div><button type=\"submit\" class=\"md:text-md block w-full text-center transition-all rounded-md font-medium py-[12px] px-[25px] text-white bg-primary-500 hover:bg-primary-400\"><span class=\"flex items-center justify-center gap-[5px]\"><i class=\"material-symbols-outlined\"> autorenew </i> Send </span></button>", 2))
            ])
          ])
        ])
      ])
    ])
  ]))
}